/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

var _style2 = require('antd/lib/message/style');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _config = require('../config');

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _config2 = require('../../utils/config');

var _tool = require('../../utils/tool');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 获取设备相关产品详情
var fetchDeviceProductDetail = function fetchDeviceProductDetail(data) {
  return function (dispatch) {
    // console.log(,'OOOOOOOOOOOOOOOOOOOOO')
    if (data.productId === '1234') {
      var _data = {
        accessDeviceType: 1,
        accessDeviceTypeName: "E10",
        accessType: 999,
        createTime: "2018-09-04 14:20:10",
        deviceCount: 1,
        factoryName: "猛犸充电",
        id: "1234",
        lastUpgradeSubVersionMap: { BMS: "版本未知", VCU: "版本未知", EIO: "版本未知", MCCU: "版本未知" },
        lastUpgradeTime: "2019-05-30 17:29:46",
        lastUpgradeVersion: "V1.24",
        name: "E10",
        networkType: 999,
        operatingSystem: 999,
        pictureUrl: "/resource//PRODUCT_IMAGE/test/2019/0517/7637.png",
        productCode: "12",
        registerNumber: "889180262575",
        remark: "e10很好",
        versionCount: 16
      };
      setTimeout(function () {
        dispatch({ type: _config.DEVICE_FECTH_PRDOCUT_DETAIL, data: _data });
      }, 100);
    } else {
      return (0, _tool.http)(_config2.apiJson.getProduct, data).then(function (data) {
        dispatch({ type: _config.DEVICE_FECTH_PRDOCUT_DETAIL, data: data });
      }).catch(function (res) {
        var msg = res.errmsg ? res.errmsg : '加载产品信息失败!';
        _message2.default.error(msg);
      });
    }
  };
};

// 增加设备
var addDevice = function addDevice(data, func) {
  return function (dispatch) {
    return (0, _tool.http)(_config2.apiJson.registerDevice, data).then(function (data) {
      _message2.default.success('设备添加成功');
      console.log(data);
      dispatch({ type: _config.ADD_DEVICE, data: data });
      func && func();
    }).catch(function (res) {
      var msg = res.errmsg ? res.errmsg : '添加设备失败!';
      _message2.default.error(msg);
    });
  };
};

// 获取设备列表
var getDeviceList = function getDeviceList(data) {
  return function (dispatch) {
    return (0, _tool.http)(_config2.apiJson.getPagedDeviceList, data).then(function (data) {
      dispatch({ type: _config.GET_DEVICE_LIST, data: data });
    }).catch(function (error) {
      return console.log(error);
    });
  };
};

// 编辑设备
var updateDevice = function updateDevice(data, func) {
  return function (dispatch) {
    return (0, _tool.http)(_config2.apiJson.updateDevice, data).then(function (data) {
      _message2.default.success('设备修改成功');
      dispatch({ type: _config.EDITE_DEVICE, data: data });
      func && func();
    }).catch(function (res) {
      var msg = res.errmsg ? res.errmsg : '修改设备失败!';
      _message2.default.error(msg);
    });
  };
};

// 删除设备
var deleteDevice = function deleteDevice(data, func) {
  return function (dispatch) {
    return (0, _tool.http)(_config2.apiJson.deleteDevice, data).then(function (data) {
      console.log(data == true);
      if (data == true) {
        _message2.default.success('设备注销成功');
        dispatch({ type: _config.DELETE_DEVICE, data: data });
        func && func();
      } else {
        _message2.default.error('注销设备失败');
      }
    }).catch(function (res) {
      var msg = res.errmsg ? res.errmsg : '注销设备失败!';
      _message2.default.error(msg);
    });
  };
};

// 获取设备详情
var getDeviceDetail = function getDeviceDetail(data) {
  return function (dispatch) {
    return (0, _tool.http)(_config2.apiJson.getDeviceDetail, data).then(function (data) {
      dispatch({ type: _config.GET_DEVICE_DETAIL, data: data });
    }).catch(function (res) {
      var msg = res.errmsg ? res.errmsg : '加载设备信息失败!';
      _message2.default.error(msg);
    });
  };
};

module.exports = { fetchDeviceProductDetail: fetchDeviceProductDetail,
  addDevice: addDevice,
  getDeviceList: getDeviceList,
  updateDevice: updateDevice,
  deleteDevice: deleteDevice,
  getDeviceDetail: getDeviceDetail
};

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "device.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/redux/actions/device.jsx
// module id = 650
// module chunks = 0